export default "__VITE_ASSET__PMEkTgaT__"